module.exports = __webpack_public_path__ + "static/media/taas.da1ed60c.svg";